import { getISO8601WeekNumber } from 'modules/contracts/helpers';
import { IPlanningKpiBucket } from 'types/kpis/IPlanningKpiBucket';
import { HEADER__WEEK } from 'translations/constants';

type TranslateFn = (key: string) => string;

export interface PlanningKpiGraphPoint {
  name: string;
  value: number;
}

const weekLabel = (date: Date, t: TranslateFn): string => `${t(HEADER__WEEK)} ${getISO8601WeekNumber(date)}`;

export const toGraphPoints = (buckets: IPlanningKpiBucket[], t: TranslateFn): PlanningKpiGraphPoint[] =>
  buckets.map(b => ({
    name: weekLabel(new Date(`${b.weekStartDate}T00:00:00`), t),
    value: b.value,
  }));

export const getErrorFallbackPoints = (t: TranslateFn): PlanningKpiGraphPoint[] => {
  const today = new Date();
  const dayOfWeek = (today.getDay() + 6) % 7;
  const currentMonday = new Date(today);
  currentMonday.setDate(today.getDate() - dayOfWeek);
  currentMonday.setHours(0, 0, 0, 0);

  return [-2, -1, 0, 1].map(offset => {
    const monday = new Date(currentMonday);
    monday.setDate(currentMonday.getDate() + offset * 7);
    return { name: weekLabel(monday, t), value: 0 };
  });
};
